module.exports = __webpack_public_path__ + "media/icons/paliwo-title-636dcfa2.png";